(function () {
    'use strict';

    angular.module("imApp").factory("consignmentBatchConsignmentsService", ['$ihttp', function ($ihttp) {
        let service = {
            listConsignments: function (parms) {
                return $ihttp.post({
                    method: 329,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
